// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class CardMemberNumberStatusResultModelResponse {
    static getAttributeTypeMap() {
        return CardMemberNumberStatusResultModelResponse.attributeTypeMap;
    }
}
CardMemberNumberStatusResultModelResponse.discriminator = undefined;
CardMemberNumberStatusResultModelResponse.attributeTypeMap = [
    {
        "name": "data",
        "baseName": "data",
        "type": "CardMemberNumberStatusResultModel"
    },
    {
        "name": "success",
        "baseName": "success",
        "type": "boolean"
    },
    {
        "name": "messages",
        "baseName": "messages",
        "type": "Array<string>"
    }
];
//# sourceMappingURL=cardMemberNumberStatusResultModelResponse.js.map